import { useEffect } from "react";

const useClickOutside = (
  ref: HTMLElement | null,
  cb: Function,
  exclude?: HTMLElement[]
) => {
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      event.stopPropagation();
      if (
        ref &&
        event.target instanceof HTMLElement &&
        !ref.contains(event.target)
      ) {
        if (exclude) {
          const isExclude = exclude
            .map(
              (node) =>
                event.target instanceof HTMLElement &&
                node.isSameNode(event.target)
            )
            .find((boo) => boo);
          if (isExclude) return;
        }
        cb();
      }
    };

    if (ref) {
      const isMobile =
        window.navigator.maxTouchPoints >= 1 || "ontouchstart" in window;

      const type: keyof DocumentEventMap = isMobile ? "touchstart" : "click";

      document.addEventListener(type, handleClickOutside);

      return () => {
        document.removeEventListener(type, handleClickOutside);
      };
    }
  }, [ref, cb, exclude]);
};

export default useClickOutside;
